import { Role } from "../../roles/_types/role";
import { minLength, prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class DDI extends Resource {
    public override type = 'ddIs';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public phoneNumber!: string;

    @prop()
    public active: boolean = true;

    @prop()
    public queueName?: string;

    @prop()
    public queueWaitTime?: number;

    @prop()
    public dialPlanId?: string;

}